export class LandParcelDto {
  constructor(public NrL?: number, public NrM?: number, public NrAdd?: string) {}
}
